import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "user" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Usuários", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "header" }
const _hoisted_6 = {
  class: "search",
  for: "search-user"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_8 = { class: "filters" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.9284 2.1001L5.99844 10.0001M5.39844 2.1001H18.5984C19.6984 2.1001 20.5984 3.0001 20.5984 4.1001V6.3001C20.5984 7.1001 20.0984 8.1001 19.5984 8.6001L15.2984 12.4001C14.6984 12.9001 14.2984 13.9001 14.2984 14.7001V19.0001C14.2984 19.6001 13.8984 20.4001 13.3984 20.7001L11.9984 21.6001C10.6984 22.4001 8.89844 21.5001 8.89844 19.9001V14.6001C8.89844 13.9001 8.49844 13.0001 8.09844 12.5001L4.29844 8.5001C3.79844 8.0001 3.39844 7.1001 3.39844 6.5001V4.2001C3.39844 3.0001 4.29844 2.1001 5.39844 2.1001Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "results"
}
const _hoisted_12 = { class: "itens" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = {
  key: 1,
  class: "no-options"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path fill=\"#171717\" d=\"M14.9999 5.96651C14.9499 5.95817 14.8916 5.95817 14.8416 5.96651C13.6916 5.92484 12.7749 4.98317 12.7749 3.81651C12.7749 2.62484 13.7332 1.6665 14.9249 1.6665C16.1166 1.6665 17.0749 2.63317 17.0749 3.81651C17.0666 4.98317 16.1499 5.92484 14.9999 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path stroke=\"#171717\" d=\"M14.1415 12.0333C15.2831 12.225 16.5415 12.025 17.4248 11.4333C18.5998 10.65 18.5998 9.36664 17.4248 8.58331C16.5331 7.99164 15.2581 7.79163 14.1165 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill=\"#171717\" d=\"M4.9749 5.96651C5.0249 5.95817 5.08324 5.95817 5.13324 5.96651C6.28324 5.92484 7.1999 4.98317 7.1999 3.81651C7.1999 2.62484 6.24157 1.6665 5.0499 1.6665C3.85824 1.6665 2.8999 2.63317 2.8999 3.81651C2.90824 4.98317 3.8249 5.92484 4.9749 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path stroke=\"#171717\" d=\"M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill=\"#171717\" d=\"M10.0001 12.1916C9.95015 12.1833 9.89181 12.1833 9.84181 12.1916C8.69181 12.1499 7.77515 11.2083 7.77515 10.0416C7.77515 8.84994 8.73348 7.8916 9.92514 7.8916C11.1168 7.8916 12.0751 8.85827 12.0751 10.0416C12.0668 11.2083 11.1501 12.1583 10.0001 12.1916Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path stroke=\"#171717\" d=\"M7.5751 14.8168C6.4001 15.6001 6.4001 16.8835 7.5751 17.6668C8.90843 18.5585 11.0918 18.5585 12.4251 17.6668C13.6001 16.8835 13.6001 15.6001 12.4251 14.8168C11.1001 13.9335 8.90843 13.9335 7.5751 14.8168Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><h1>Nenhum usuário foi encontrado</h1>", 2)
const _hoisted_17 = [
  _hoisted_15
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.9284 2.1001L5.99844 10.0001M5.39844 2.1001H18.5984C19.6984 2.1001 20.5984 3.0001 20.5984 4.1001V6.3001C20.5984 7.1001 20.0984 8.1001 19.5984 8.6001L15.2984 12.4001C14.6984 12.9001 14.2984 13.9001 14.2984 14.7001V19.0001C14.2984 19.6001 13.8984 20.4001 13.3984 20.7001L11.9984 21.6001C10.6984 22.4001 8.89844 21.5001 8.89844 19.9001V14.6001C8.89844 13.9001 8.49844 13.0001 8.09844 12.5001L4.29844 8.5001C3.79844 8.0001 3.39844 7.1001 3.39844 6.5001V4.2001C3.39844 3.0001 4.29844 2.1001 5.39844 2.1001Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7 7L17 17M7 17L17 7",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", null, "Filtros", -1)
const _hoisted_22 = { class: "filters" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", null, "Por setores", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_26 = { class: "action" }

import { ref, onMounted, computed } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import { OrganizationModel } from '@/models/OrganizationModel'
import { AxiosResponse } from 'axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { useAxios } from '@/api/axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const isMobileOptionsFilterOpen = ref<boolean>(false)
const isGlobalFiltersModalOpen = ref<boolean>(false)
const filter = ref<{ with: string[], organization_id?: number, search_user: RegExp }>({ with: ['users.roles'], search_user: new RegExp('.*.*', 'i') })
const organizations = ref<OrganizationModel[]>()
const filteredOrganizations = computed(() => organizations.value?.filter((org) => {
  const hasAnyUser = org.users?.filter((u) => filter.value.search_user.test(u.name)).length
  const isValid = org.id === filter.value.organization_id || !filter.value.organization_id

  return hasAnyUser && isValid
}))
const axios = useAxios()

const toggleOverflow = () => {
  isMobileOptionsFilterOpen.value = !isMobileOptionsFilterOpen.value
  document.body.style.overflow = isMobileOptionsFilterOpen.value ? 'hidden' : 'auto'
}

function getOrganizations () {
  organizations.value = undefined
  axios.get('/api/organizations', { params: filter.value })
    .then((res: AxiosResponse<OrganizationModel[]>) => {
      organizations.value = res.data
    })
}

onMounted(() => {
  getOrganizations()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createElementVNode("input", {
          autocomplete: "off",
          type: "text",
          placeholder: "Digite sua busca",
          id: "search-user",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (filter.value.search_user = new RegExp(`.*${($event.target as HTMLInputElement).value}.*`, 'i'))),
          onKeydown: _withKeys(getOrganizations, ["enter"])
        }, null, 32),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "tooltip",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isGlobalFiltersModalOpen.value = true))
        }, _hoisted_10)
      ])
    ]),
    (filteredOrganizations.value && filteredOrganizations.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOrganizations.value, (organization) => {
            return (_openBlock(), _createElementBlock("section", null, [
              _createElementVNode("h1", null, _toDisplayString(organization.name), 1),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.users?.filter((u) => filter.value.search_user?.test(u.name)), (user) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("h1", null, _toDisplayString(user.name) + " " + _toDisplayString(user.last_name), 1),
                    _createElementVNode("h2", null, _toDisplayString(user.roles[0].name), 1)
                  ]))
                }), 256))
              ])
            ]))
          }), 256))
        ]))
      : (filteredOrganizations.value && !filteredOrganizations.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 })),
    _createElementVNode("nav", {
      class: _normalizeClass([{active: isMobileOptionsFilterOpen.value}, "action-filters"]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleOverflow()))
    }, [
      _createElementVNode("button", {
        onClick: [
          _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
          _cache[4] || (_cache[4] = ($event: any) => {isGlobalFiltersModalOpen.value = true; toggleOverflow();})
        ]
      }, _hoisted_19),
      _hoisted_20
    ], 2),
    _createVNode(MyModal, {
      width: '554px',
      className: 'global-filters',
      isOpen: isGlobalFiltersModalOpen.value,
      toggleModal: (v) => isGlobalFiltersModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("section", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
              return (_openBlock(), _createElementBlock("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "organization_id",
                  id: "id",
                  value: organization.id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filter.value.organization_id) = $event))
                }, null, 8, _hoisted_24), [
                  [_vModelRadio, filter.value.organization_id]
                ]),
                _hoisted_25,
                _createElementVNode("p", null, _toDisplayString(organization.name), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("input", {
            type: "button",
            value: "Limpar",
            onClick: _cache[7] || (_cache[7] = ($event: any) => {isGlobalFiltersModalOpen.value = false; filter.value.organization_id = undefined})
          })
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})